'use strict';
// 
module.exports = {
    initialize: function($callbackFunction) {
        grecaptcha.ready(function() {
            // These two selectors will be always present inside the page because integrating the reCaptchaV3.isml is mandatory
            grecaptcha.execute($('#recaptchaV3ApiKey').val(), {action: 'submit'}).then(function(validationToken) {
                // Insert the validation token inside the form input field. Then the .serialize() will get the value automatically
                $('#captchaToken').val(validationToken);
                // Execute the function
                $callbackFunction(validationToken)
            });
        });
    }
}
